import React from 'react';
import HubPage from '../../ui-components/HubPage';

const ITEM_META = {
  '/ritmo': { icon: 'subtitles', desc: 'Ondertitel Studio — transcriberen, reviewen en renderen, projecten per klant' },
  '/callsheets': { icon: 'description', desc: 'Callsheets voor draaidagen' },
  '/script-breakdown': { icon: 'movie_filter', desc: 'Script analyse en shot planning' },
  '/video-qa': { icon: 'bug_report', desc: 'Review en feedback op edits' },
  '/ondertiteling': { icon: 'subtitles', desc: 'Genereer, beheer en exporteer ondertitels' },
  '/name-title-generator': { icon: 'badge', desc: 'Naamtitels renderen vanuit huisstijl templates' },
  '/formaat-omzetten': { icon: 'aspect_ratio', desc: 'Video omzetten naar 9:16, 4:5 of 1:1 met slim kader (in Flow, Full Frame-account)' },
  '/narrowcasting': { icon: 'tv', desc: 'Content voor narrowcasting schermen' },
  '/video-downloader': { icon: 'download', desc: "Download video's van YouTube, Vimeo en meer" },
  '/pptx-video-replacer': { icon: 'slideshow', desc: "PowerPoint met video's omzetten naar PDF" },
  '/pdf-combiner': { icon: 'description', desc: "Meerdere PDF's samenvoegen" },
  '/color-converter': { icon: 'palette', desc: 'Live conversie tussen HEX, RGB, HSL, HSV en CMYK + WCAG check' },
  '/qr-generator': { icon: 'qr_code_2', desc: 'QR-codes met stijlopties en logo — export naar PNG en SVG' },
  '/MeetingDashboard': { icon: 'groups', desc: 'Automatische meeting transcripties en actiepunten' },
  '/video-search': { icon: 'video_library', desc: 'Doorzoek video-content met AI' },
  '/explainer-script': { icon: 'auto_fix_high', desc: 'Genereer explainer video scripts' },
  '/effie-guide': { icon: 'emoji_events', desc: 'AI-gids voor Effie Award inzendingen' },
};

export default function ProductieHub() {
  return (
    <HubPage
      sectionKey="productie"
      subtitle="Video, ondertiteling en productietools"
      headerIcon="theaters"
      headerAccent={{ color: '#635983', bg: '#dbcdff' }}
      itemMeta={ITEM_META}
    />
  );
}
